module.exports = __webpack_public_path__ + "img/ramezani.5ba8b018.jpg";